jQuery(document).ready(function($) {
    $('#SortBy-collection').on('change', function () {
        const sortBy = jQuery(this).val();
        const url = new URL(window.location.href);

        url.searchParams.set('sort_by', sortBy);

        window.location.href = url.toString();
    });
    $('.product-card__info .product-short-desc p, .product__block .metafield-rich_text_field p').each(function () {
        var node = this.firstChild;

        while (node) {
            if (node.nodeName === 'BR') {
                var next = node.nextSibling;

                // bỏ qua text node (space / newline)
                while (next && next.nodeType === 3 && !$.trim(next.textContent)) {
                    next = next.nextSibling;
                }

                if (next && next.nodeName === 'BR') {
                    $(next).remove(); // xóa br thừa
                }
            }

            node = node.nextSibling;
        }
    });

    $(".open-filter").click(function() {
        $(this).toggleClass("active");
        $("body .collection__content #FacetFiltersContainer").toggleClass("active");
    });

    jQuery('.product--collapsible-wrapper .tab-title').click(function() {
        $(this).next().slideToggle(100).parent().toggleClass('closed')
    })
    
    var swiper = new Swiper(".relate-product-wrapper", {
        slidesPerView: 4,
        navigation: {
            nextEl: ".relate-product-wrapper .swiper-button-next",
            prevEl: ".relate-product-wrapper .swiper-button-prev",
        },
        breakpoints: {
            0: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
        }
    });

    var swiper = new Swiper(".upsell-product-wrapper", {
        slidesPerView: 4,
        navigation: {
            nextEl: ".upsell-product-wrapper .swiper-button-next",
            prevEl: ".upsell-product-wrapper .swiper-button-prev",
        },
        breakpoints: {
            0: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
        }
        
    });

    setTimeout(() => {
        var swiper = new Swiper(".auto-relate-product-wrapper", {
            slidesPerView: 5,
            navigation: {
                nextEl: ".auto-relate-product-wrapper .swiper-button-next",
                prevEl: ".auto-relate-product-wrapper .swiper-button-prev",
            },
            breakpoints: {
                0: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                1024: {
                    slidesPerView: 3.5,
                },
                1366: {
                    slidesPerView: 5,
                },
            }
        });
    }, 2000);
});

$(document).ready(function () {
    $('#modal-a').click(function(){
        $('[data-id=modal-a]').addClass('show');
    })
    $('#modal-b').click(function(){
        $('[data-id=modal-b]').addClass('show');
    })
    jQuery('.modal-product .modal-overview').click(function(){
        $('.modal-product').removeClass('show');
    })

    $('.md-close-btn').click(function(){
        $(this).closest('.modal-product').removeClass('show')
    })
    $('.tab-item > .tab-content .content-box').each(function () {
        var $content = $(this);
        var maxHeight = 300;

        if ($content[0].scrollHeight > maxHeight) {

            // thêm class để style
            $content.addClass('is-collapsed gradient-mask')
                    .css('max-height', maxHeight + 'px')
                    .css('overflow', 'hidden');

            // tạo button
            var $btn = $('<button class="toggle-content">+ Mehr anzeigen</button>');
            $content.after($btn);

            $btn.on('click', function () {

                if ($content.hasClass('is-collapsed')) {
                    $content
                        .removeClass('is-collapsed gradient-mask')
                        .addClass('is-expanded')
                        .css('max-height', 'none');

                    $btn.text('- Weniger anzeigen');
                } else {
                    $content
                        .removeClass('is-expanded')
                        .addClass('is-collapsed gradient-mask')
                        .css('max-height', maxHeight + 'px');

                    $btn.text('+ Mehr anzeigen');
                }

            });
        }
    });
});


document.addEventListener("algolia.hooks.initialize", () => {
	algoliaShopify.hooks.registerHook("beforeAutocompleteOptions", (options) => {
        const originalOnSubmit = options.onSubmit;
        options.placeholder = "Wonach suchen Sie?";
        options.onSubmit = function ({ state }) {
            const query = state.query || "";
            console.log("Intercepted Algolia submit:", query);
            window.location.href =
            window.Shopify.routes.root +
            "a/search?q=" +
            encodeURIComponent(query);
        };

		return options;
	});
});




